// ABOUTME: Hook returning a predicate that tells whether the current user may add a favorite on a
// ABOUTME: node of a given hierarchy, from the favoriteRoles system setting and the user's roles.

import { useAuth } from '@src/hooks';
import { SettingsContext } from '@src/modules/setting/SettingsContext';
import { useCallback, useContext } from 'react';

import { canAddFavorite } from '../utils/canAddFavorite';

export function useCanAddFavorite(): (hierarchyId: string) => boolean {
    const { favoriteRoles, prototype } = useContext(SettingsContext);
    const catalogHierarchies = prototype?.hierarchies;
    const { hasUserRole } = useAuth();

    return useCallback(
        hierarchyId => canAddFavorite(favoriteRoles, hierarchyId, catalogHierarchies, hasUserRole),
        [favoriteRoles, catalogHierarchies, hasUserRole],
    );
}
